import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parse, isValid } from "date-fns";
import { FaRegCalendarAlt } from "react-icons/fa";

const CustomDatePicker = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  maxDate,
  placeholderText = "yyyy-mm-dd",
  dateFormat = "yyyy-MM-dd",
  className = "form-control ps-5",
}) => {
  const handleChangeRaw = (e) => {
    const input = e.target.value;
    if (typeof input === "string" && input.trim()) {
      const parsed = parse(input, "dd/MM/yyyy", new Date());
      if (isValid(parsed)) {
        onChange(parsed);
      }
    }
  };

  return (
    <div className="custom-date-picker d-flex align-items-center position-relative">
      <FaRegCalendarAlt className="calendar-icon" />
      <DatePicker
        id={name}
        name={name}
        selected={value || null}
        onChange={onChange}
        onBlur={onBlur}
        onChangeRaw={handleChangeRaw}
        placeholderText={placeholderText}
        dateFormat={dateFormat}
        className={`${className} ${touched && error ? "is-invalid" : ""}`}
        dropdownMode="select"
        showMonthDropdown
        showYearDropdown
        maxDate={maxDate}
        autoComplete="off"
        popperClassName="custom-datepicker-popper"
        popperPlacement="bottom-start"
        // popperContainer={({ children }) => (
        //   <div style={{ zIndex: 1700 }}>{children}</div>
        // )}
        portalId="datepicker-portal-root"
      />
    </div>
  );
};

export default CustomDatePicker;
